import { RECALL_TYPEOFCHANGE,USER_TYPE, DISRUPTION_TYPEOFCHANGE } from '../../../../misc/commons'
import supplierRecallService from '../../../../services/supplier/supplier-recall'
import providerRecallService from '../../../../services/provider/recall'
import store from '../../../../store'
import moment from 'moment-timezone'

export default {
    props: {
        communicationType: { type: String, default: null }
    },
    data() {
        return {
            communicationId: null,
            type: null,
            content: '',
            typeofchange: null,
            updatenotification: false,
            recallTypeOfChange: this.communicationType == 'RECALL' ? RECALL_TYPEOFCHANGE : DISRUPTION_TYPEOFCHANGE,
            sendType: 'SEND_UPDATE_NOTI',
            orgType: store.state.userType,
            service: store.state.userType ==USER_TYPE.SUPP ? supplierRecallService : providerRecallService,
        }
    },
    methods: {
        sendNotification(eve) {
            if (eve) {
                this.updatenotification = false
            }
            else {
                this.updatenotification = true
            }
        },
        forceRerender(communicationId, communicationType) {
            this.communicationId = communicationId
            this.type = communicationType
            this.content = ''
            this.typeofchange = null
            this.updatenotification = false
            this.$refs.modal.show()
        },
        async onClose() {
            this.$refs.modal.hide()
            if(this.orgType == USER_TYPE.PROV) {
                const confirm = await this._showConfirm(
                    'Do you want to send an update email to your organization’s NotiSphere users?',
                    { title: 'Send email?', variant: 'warning', saveLabel: 'Yes', cancelLabel: 'No' }
                )
                if(confirm) {
                    providerRecallService.sendRecallUpdateNotification(this.communicationId, this.type).then(res => {
                        if (!res.error) {
                            this._showToast('Sent successfully!')
                        }
                    })
                }
            }
            this.communicationId = null
            this.content = ''
        },
        async onComplete() {
            this.$refs.modal.hide()
            if(this.orgType == USER_TYPE.PROV) {
                const confirm = await this._showConfirm(
                    'Do you want to send an update email to your organization’s NotiSphere users?',
                    { title: 'Send email?', variant: 'warning', saveLabel: 'Yes', cancelLabel: 'No' }
                )
                if(confirm) {
                    providerRecallService.sendRecallUpdateNotification(this.communicationId, this.type).then(res => {
                        if (!res.error) {
                            this._showToast('Sent successfully!')
                        }
                    })
                }
            }
            this.$emit('onCompleted')
            this.communicationId = null
            this.content = ''
            this.typeofchange = null
            this.updatenotification = false
        },

        save() {
            if (this.orgType == USER_TYPE.PROV) {
                if (this.content.trim() !== '') {
                    providerRecallService.saveRecallChangeHistory({ id: this.communicationId, content: this.content.trim() })
                        .then(res => {
                            if (!res.error) {
                                this.onComplete()
                            }
                        })
                }
            }
            if (this.orgType == USER_TYPE.SUPP) {
                if (this.content.trim() !== '') {
                    supplierRecallService.saveRecallChangeHistory({ id: this.communicationId, communicationType: this.communicationType, content: this.content.trim(), typeofchange: this.typeofchange, updatenotification: this.updatenotification })
                        .then(res => {
                            if (!res.error) {
                                this.onClomplete()
                            }
                        })
                }
            }
            if (this.updatenotification == true) {
                const notificationDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())
                supplierRecallService.sendNotification(this.communicationId, this.sendType, this.communicationType, moment(notificationDate).format('YYYY/MM/DD'))
                    .then(res => {
                        if (!res.error) {
                            this._showToast('Sent successfully!')
                        }
                    })

            }
            else {
                this.onClomplete()
            }
        }
    }
}